// Dostawca kontekstu firmy (contexts/CompanyContext).
//
// F8 (docs/model-kluczy-firmowych.md): ZASTĘPUJE UserProfileContext.Provider w App.tsx —
// jest teraz jedynym źródłem tożsamości "z kim/jaką firmą pracuje zalogowany". Flaga
// `companyModelFlag` z F1 (rollout stopniowy) tu już nie obowiązuje: `/api/company/current`
// jest realnym, zawsze dostępnym endpointem (CompanyController), a profile — jedyna
// alternatywna ścieżka — zniknęły w F5. Zapytanie idzie więc BEZWARUNKOWO.
//
// Nie trzyma i nie będzie trzymał klucza prywatnego firmy (I4) — ten jest odtwarzany
// z grantu przy starcie sesji (App.tsx) i żyje wyłącznie w pamięci warstwy krypto
// (utils/companyContentKeys). Ten dostawca niesie wyłącznie TOŻSAMOŚĆ i uprawnienia.

import { useEffect, useMemo } from "react";

import companyService from "api/companyService";
import CompanyContext, { ICompanyContext } from "contexts/CompanyContext";
import { setActiveCompanyId } from "utils/getCompanyId";

import { FC, Props } from "./typings";

const CompanyProvider: FC<Props> = ({ children }) => {
  const { data, isLoading } = companyService.useGetCurrentCompany(true);

  const response = data?.data;

  const value = useMemo<ICompanyContext>(() => {
    const company = response?.Company ?? null;
    const privileges = response?.Privileges ?? [];

    return {
      company,
      privileges,
      // D2: konto bez firmy jest stanem poprawnym, nie błędem.
      hasCompany: (response?.HasCompany ?? false) && company !== null,
      isLoading,
      hasPrivilege: (privilege) => privileges.includes(privilege as string),
    };
  }, [response, isLoading]);

  // Mirror synchroniczny (bez kontekstu Reacta) dla utils/getCompanyId — wołane w
  // dziesiątkach miejsc jako zwykła funkcja, poza drzewem komponentów.
  useEffect(() => {
    setActiveCompanyId(value.company?.Id ?? null);
  }, [value.company?.Id]);

  return (
    <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>
  );
};

export default CompanyProvider;
